/// User will select debt and/or on going  and/or one time payments to pay for
import React from 'react';
import Parent from '../../common/parent';
import { withTranslation } from 'react-i18next';
import {BllinkLogger} from '../utils/bllink_loggers';
import InstallmentsSelect from '../../common/installmentsSelect';
import { constants } from "../constants/constants";
import './paymentLastPageSingleComponent.scss'

export class PaymentLastPageSingleComponent extends Parent {

    calcMonthsText(selectedMonths){
        return this.calcMonthsTextForSelectBox(selectedMonths)
    }

    selectBox(props, isOneTimePayment){
        const {t} = props;

        const data = this.gatherInput(props);

        return (
            <div className="col-md-6 check-1">
                <h4 className={`${data.openTitle} label`}>{data.title}</h4>
                {data.closedTitle}

                <div className={data.mainDiv + ' select-content'}>
                    <div className="row">
                        <div className="col-sm-6 selectBoxText col-8">
                            {data.expenseTypeText}
                            <div className='label'>{t('payments.total_to_pay')}</div>
                            <div className='label'>{t('payments.number_of_installments')}</div>
                            {/* changed for this ticket: https://app.asana.com/0/1201110619555847/1201694011606091 */}
                            <div className='label'>{t('payments.first_payment')}</div>
                            {data.monthRelatedText}
                        </div>
                        <div className="col-sm-6 selectBoxText bold col-4">
                            {data.expenseType}
                            {this.installmentSelectHtml(props, data.extraData, isOneTimePayment)}
                            {data.monthRelatedData}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    gatherInput(props){

        const {t} = props;

        const title = props.title || props.settings.title;
        // sub title  (long description) in the case of one time payments
        let subTitle = props.settings.sub_title;
        let openTitle, closedTitle, mainDiv
        if (this.props.hideSelectInstallments){
            BllinkLogger.info(`hiding select`)
            openTitle = ""
            closedTitle = ""
            mainDiv = ""
        }else{
            BllinkLogger.info(`showing select`)
            openTitle = "d-none d-md-block"
            closedTitle = <h4 className="d-sm-block d_sm_block d-md-none js-clickable-box">{title}</h4>
            mainDiv = "d-none text-center tog_new d-md-block"

        }


        const neededMonths = (props.settings.selectedMonths || []).filter(month => month.selected);
        const hasMonthRelated = neededMonths?.length > 0;

        let monthRelatedData, monthRelatedText
        if (hasMonthRelated){
            BllinkLogger.info(`is MonthRelated`);
            monthRelatedData = <div className='amount-in-box'>{this.calcMonthsText(neededMonths)}</div>
            monthRelatedText = <div className='label'>{t('payments.months_selected')}</div>
        }else{
            BllinkLogger.info(`is NOT MonthRelated`);
            monthRelatedData = ''
            monthRelatedText = ''
        }

        if (subTitle){
            BllinkLogger.info(`creating sub title html`)
            subTitle = <p className="pr-4">{subTitle}</p>
        }

        const expenseTypeText = props.isExpense ? <p>{t('expenses.expense_type')}</p> : '';
        const expenseType = props.isExpense ? <p>{t(`expenses.expenseTypes.${props.settings.expenseType}`)}</p> : '';

        return {
            title: title,
            openTitle: openTitle,
            mainDiv: mainDiv,
            closedTitle: closedTitle,
            subTitle: subTitle,
            monthRelatedData: monthRelatedData,
            monthRelatedText: monthRelatedText,
            expenseTypeText,
            expenseType,
            extraData:{
                isMonthRelated: hasMonthRelated,
                isOneTime: !hasMonthRelated
            }
        }
    }

    installmentSelectHtml(props, data, isOneTimePayment){
        return (
            <InstallmentsSelect
                currency={props.settings.selectedMonths && props.settings.selectedMonths[0]?.total?.currency || props.settings.currency}
                maxNumberOfInstallments={props.settings.maxInstallments}
                selectedNumberOfInstallments={props.ignoreCache ? props.settings.numberOfInstallments : null}
                firstPayment={props.settings.firstPaymentAmount}
                totalReward={props.settings.totalReward}
                total={props.settings.total}
                ignoreMaxInstallments={props.ignoreMaxInstallments}
                classNameDiv={props.className || "icon-dropdown-new-last-1"}
                selectID={props.id || "payment-specific-page-selection-next"}
                name={props.typeOfPayment}
                onChange={props.onChange}
                hideSelectInstallments={props.hideSelectInstallments}
                data={data}
            />
        )
    }

    render() {
       const isExpense = this.props.isExpense;
       const isOneTimePayment = this.props.isOneTimePayment ?? (this.props.settings && this.props.settings.building_one_time_payment_id);
       const isEmptyDataSent = (
         !this.props.settings ||
         !isExpense && isOneTimePayment && this.props.settings?.building_one_time_payment_id == null ||
         !isOneTimePayment && (this.props.settings?.selectedMonths?.length ?? 0) === 0
       );

       // in cases where plan has still not been processed
       const paymentIsSuccessful = (
         isExpense && constants.PaymentPlanDetailsStatus.PENDING === this.props.settings?.status ||
         constants.PaymentPlanDetailsStatus.ALL_SUCCESS.includes(this.props.settings?.status)
       );
       const shouldHide = (!paymentIsSuccessful && this.props.hideUnsuccessful);
       BllinkLogger.info(`single select box props `, this.props);
       BllinkLogger.info(`paymentIsSuccessful ${paymentIsSuccessful} , isOneTimePayment ${isOneTimePayment} isEmptyDataSent ${isEmptyDataSent}`);

       if (isEmptyDataSent || shouldHide){
           return <div/>
       }
       return this.selectBox(this.props, isOneTimePayment)
    }
}


export default withTranslation()(PaymentLastPageSingleComponent);
